export enum BadgeStatus {
  activated = 'activated',
  active = 'active',
  approved = 'approved',
  authorized = 'authorized',
  banned = 'banned',
  blocked = 'blocked',
  cancelled = 'cancelled',
  confirmed = 'confirmed',
  deactivate = 'deactivate',
  deactivated = 'deactivated',
  declined = 'declined',
  default = 'new',
  done = 'processed',
  error = 'error',
  expired = 'expired',
  in_progress = 'in_progress',
  inactive = 'inactive',
  limit_exceeded = 'limit_exceeded',
  limited = 'limited',
  new = 'new',
  no_response = 'no_response',
  non_verified = 'non_verified',
  none = 'none',
  onboarding = 'onboarding',
  paid = 'paid',
  pending = 'pending',
  processed = 'processed',
  rejected = 'rejected',
  requires_confirmation = 'requires_confirmation',
  reversed = 'reversed',
  reverted = 'reverted',
  sent = 'sent',
  stopped = 'stopped',
  verified = 'verified',
  verifying = 'verifying',
  manual = 'manual',
  closed = 'closed',
}

export const BADGE_STATUSES = BadgeStatus;

// DEBT: Make new enum only with statuses that are used in transactions
// export enum TransactionStatus {
//   limited = 'limited',
//   pending = 'pending',
//   declined = 'declined',
//   processed = 'processed',
//   error = 'error',
//   rejected = 'rejected',
//   reverted = 'reverted',
//   cancelled = 'cancelled',
// }

const REPEATABLE_STATUSES = [
  BADGE_STATUSES.processed,
  BADGE_STATUSES.declined,
  BADGE_STATUSES.error,
  BADGE_STATUSES.cancelled,
];

export function isRepeatableStatus(status: BadgeStatus): boolean {
  return REPEATABLE_STATUSES.includes(status);
}
